module.exports = __webpack_public_path__ + "208e7d8424cf7beecf4c000a45c96487.svg";